import { Navigate, useLocation } from "react-router-dom";
import { Route, Routes } from "react-router";
import { Box } from "@mui/material";
import { lazy, Suspense } from "react";
import DelayedFallback from "../components/loading/DelayedFallback";

const Header = lazy(() => import("../components/header/Header"));
const LoginForm = lazy(() => import("../pages/externalPages/LoginForm"));
const PasswordReset = lazy(() => import("../pages/externalPages/PasswordReset"));
const PrivacyPolicy = lazy(() => import("../pages/externalPages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("../pages/externalPages/TermsOfUse"));
// const DonorFooter = lazy(() => import("../components/donor/DonorFooter"));
const SelectAccountType = lazy(() => import("../pages/externalPages/SelectAccountType"));
const CreateAccount = lazy(() => import("../pages/externalPages/CreateAccount"));
const EmailVerification = lazy(() => import("../pages/externalPages/EmailVerification"));
const VerifyReminder = lazy(() => import("../pages/externalPages/VerifyReminder"));
const ErrorPage = lazy(() => import("../pages/externalPages/ErrorPage"));

export default function ExternalRoutes() {
  function RedirectToLoginIfNotMatch() {
    const location = useLocation();
    const allowedPaths = [
      "/login",
      "/password-reset",
      "/terms-of-use",
      "/privacy-policy",
      "/select-account-type",
      "/create-account",
      "/email-verification",
      "/verify-reminder",
      "/error",
    ];

    function checkAuthToken() {
      return localStorage.getItem("idToken") !== null;
    }

    // Check if current path is in the allowed paths or if the user is authenticated
    if (allowedPaths.includes(location.pathname) || checkAuthToken()) {
      return null; // Render nothing if the path is allowed or user is authenticated
    }

    // Redirect to login if path is not allowed and user is not authenticated
    return <Navigate to="/login" />;
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 0,
        backgroundColor: "background.main",
        height: "100%",
        minHeight: "100vh",
      }}
    >
      <Header />
      {/* <Box
        sx={{
          height: "calc(100vh - 100px)",
          mt: 4,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: '1px solid red'
        }}
      > */}
      <Suspense fallback={<DelayedFallback />}>
        <Routes>
          {/* default path is /login */}
          <Route exact path="/" element={<Navigate to="login" />} />
          <Route path="login" element={<LoginForm />} />
          <Route path="password-reset" element={<PasswordReset />} />
          <Route path="terms-of-use" element={<TermsOfUse />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="select-account-type" element={<SelectAccountType />} />
          <Route path="create-account" element={<CreateAccount />} />
          <Route path="email-verification" element={<EmailVerification />} />
          <Route path="verify-reminder" element={<VerifyReminder />} />
          <Route path="error" element={<ErrorPage />} />
          {/* any invalid endpoints will point to the login page */}
          {/* This was causing all refreshes to land back at "/"... */}
          <Route path="*" element={<RedirectToLoginIfNotMatch />} />
        </Routes>
      </Suspense>
      {/* <DonorFooter></DonorFooter> */}
      {/* </Box> */}
    </Box>
  );
}
